/**
 * @export
 * @enum {string}
 * This enum is a collection of locale codes we use
 */
export enum LocaleEnum {
  English = 'en-GB',
  French = 'fr-FR',
  UnitedStates = 'en-US',
}
